import React, { useEffect } from "react"
import { pageTitle } from "../../helper"
import Div from "../Div"
import PageHeading from "../PageHeading"
import Spacing from "../Spacing"
import { basepath } from "../../App"
import { CarSimple, FlowerLotus, PawPrint, Wrench } from "phosphor-react"
import { ToastContainer } from "react-toastify"
import { useSolicitationStorage } from "../CheckPreviousSolicitationContext"
import { SeguroAppForm } from "../ClienteFluxo/SeguroAppForm"
import { CarroReservaForm } from "../ClienteFluxo/CarroReservaForm"
import { FuneralForm } from "../ClienteFluxo/FuneralForm"
import { VidrosForm } from "../ClienteFluxo/VidrosForm"
import { PetForm } from "../ClienteFluxo/PetForm"
import { ReparosForm } from "../ClienteFluxo/ReparosForm"
import { SideMenu } from "../SideMenu"
import { Ambulance } from "lucide-react"

export default function ClientePage({ currentPage }) {
  pageTitle("Área do Cliente")

  const {
    handleAPP,
    handleCarroReserva,
    isOnStart,
    isOnSeguroAPPForm,
    isOnCarroReservaForm,
    isOnFuneralForm,
    handleFuneralForm,
    isOnVidrosForm,
    handleVidrosForm,
    isOnPetForm,
    handlePetForm,
    isOnReparosForm,
    resetHandlingFormsPage,
    handleReparosForm,
  } = useSolicitationStorage()

  function handlePage(page) {
    if (page) {
      switch (page) {
        case "CR":
          handleCarroReserva()
          break
        case "APP":
          handleAPP()
          break
        case "FF":
          handleFuneralForm()
          break
        case "VF":
          handleVidrosForm()
          break
        case "PF":
          handlePetForm()
          break
        case "PR":
          handleReparosForm()
          break
        default:
          resetHandlingFormsPage()
      }
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    handlePage(currentPage)
  }, [])

  return (
    <>
      <ToastContainer />
      <PageHeading
        title="Área do Cliente"
        bgSrc={`${basepath}/img/_1.png`}
        pageLinkText="Area do Cliente"
      />

      <SideMenu />

      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row justify-content-between">
          <Div className="col-12 d-flex justify-content-between align-items-end">
            <Div className="cs-section_heading cs-style1">
              <h3 className="cs-section_subtitle">Solicitação</h3>
              <h2 className="fade-in cs-section_title">
                {isOnStart
                  ? "Qual servico deseja solicitar?"
                  : "Preencha os dados a seguir"}
              </h2>
            </Div>
          </Div>
          <Div className="d-flex flex-wrap align-items-center gap-3 my-5">
            <button
              className={`benefit_btn ${
                isOnCarroReservaForm && "benefit_active"
              }`}
              type="button"
              onClick={handleCarroReserva}
            >
              <CarSimple size={40} color="#fff" />
              <span className="benefit_btn_tooltip">Carro Reserva</span>
            </button>
            <button
              className={`benefit_btn ${isOnSeguroAPPForm && "benefit_active"}`}
              type="button"
              onClick={handleAPP}
            >
              <Ambulance size={40} color="#fff" />
              <span className="benefit_btn_tooltip">Seguro APP</span>
            </button>
            <button
              className={`benefit_btn ${isOnFuneralForm && "benefit_active"}`}
              type="button"
              onClick={handleFuneralForm}
            >
              <FlowerLotus size={40} color="#fff" />
              <span className="benefit_btn_tooltip">Funeral</span>
            </button>
            <button
              className={`benefit_btn ${isOnVidrosForm && "benefit_active"}`}
              type="button"
              onClick={handleVidrosForm}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 535 286"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M58.453 1.603C51.049 3.593 45.787 6.841 40.075 12.948C31.772 21.824 30.927 24.748 26.415 60.242C22.352 92.196 22.297 94.985 25.666 97.781C26.46 98.441 35.383 101.9 45.493 105.469L63.875 111.956L76.402 124.523C86.311 134.463 88.616 137.277 87.429 137.988C86.604 138.482 80.982 142.625 74.937 147.193C63.729 155.663 61.578 158.472 62.743 163.115C63.074 164.432 68.088 171.472 73.887 178.759C79.685 186.045 84.429 192.381 84.429 192.838C84.429 193.295 78.017 198.183 70.179 203.701L55.929 213.733L33.429 216.902C11.975 219.924 10.809 220.201 8.355 222.855C5.957 225.447 5.583 227.265 2.89 249.382L0 273.127L2.338 277.534C3.983 280.636 5.918 282.542 8.868 283.97C13.047 285.994 13.871 286 267.429 286C520.987 286 521.811 285.994 525.99 283.97C528.954 282.535 530.875 280.636 532.546 277.485L534.91 273.029L525.568 197.765C520.43 156.369 515.844 120.7 515.378 118.5C514.374 113.767 511.36 111 507.207 111C505.557 111 498.598 112.662 491.742 114.693C482.334 117.48 478.866 118.127 477.603 117.331C476.682 116.751 464.338 106.989 450.172 95.638C430.295 79.712 423.768 75 421.583 75C419.804 75 413.142 78.342 403.648 84C395.34 88.95 388.044 93 387.435 93C385.982 93 328.59 63.069 327.899 61.951C327.607 61.478 324.926 48.927 321.941 34.06C318.956 19.192 316.042 6.145 315.464 5.065C312.594 -0.297997 320.109 -0.00499811 186.956 0.0660019C81.954 0.122002 63.127 0.346997 58.453 1.603ZM331.506 2.589C328.983 4.712 328.429 5.923 328.429 9.317C328.429 13.394 328.812 13.84 353.701 38.728C377.415 62.442 379.196 64 382.59 64C384.58 64 387.162 63.213 388.328 62.25C389.626 61.179 394.334 50.649 400.467 35.101C409.766 11.528 410.406 9.46 409.374 6.334C407.332 0.145999 406.389 0 368.555 0H334.582L331.506 2.589ZM420.786 0.954002C417.836 2.196 415.429 5.9 415.429 9.196C415.429 12.587 442.502 62.423 446.307 66.033C448.789 68.389 450.794 68.798 474.952 71.869C503.434 75.489 505.137 75.4 507.854 70.145C509.239 67.466 509.155 65.481 506.913 47.852C503.957 24.616 501.96 19.485 492.446 10.676C482.254 1.24 479.602 0.608 448.929 0.306C434.629 0.166 421.965 0.457002 420.786 0.954002ZM301.362 23.25C301.953 26.138 304.406 38.336 306.814 50.358C310.497 68.751 311.566 72.576 313.56 74.487C317.027 77.81 385.217 113 388.189 113C389.603 113 397.246 109.034 405.571 103.979L420.429 94.959L445.614 115.149C459.466 126.253 472.066 135.97 473.613 136.742C476.167 138.016 477.436 137.848 487.432 134.91C493.485 133.131 498.621 131.861 498.844 132.088C499.324 132.575 515.448 262.459 515.437 265.75L515.429 268H267.429H19.429V265.293C19.429 261.77 22.52 237.628 23.041 237.077C23.261 236.845 32.01 235.422 42.482 233.916C52.955 232.41 62.189 230.922 63.003 230.61C63.817 230.297 73.735 223.434 85.043 215.358C106.089 200.327 108.194 198.183 106.912 193.077C106.567 191.702 101.318 184.305 95.248 176.639C86.969 166.183 84.552 162.497 85.571 161.886C86.318 161.437 92.095 157.117 98.41 152.285C110.092 143.346 112.282 140.52 111.113 135.89C110.781 134.576 102.454 125.167 92.61 114.983L74.711 96.465L59.32 91.197C50.855 88.3 43.398 85.6 42.749 85.198C41.861 84.649 42.402 77.938 44.93 58.136C47.928 34.659 48.571 31.384 50.859 27.927C52.27 25.794 54.555 23.308 55.936 22.403C62.664 17.995 59.886 18.09 183.108 18.044L300.287 18L301.362 23.25ZM386.968 19.878C385.571 24.278 379.873 37.759 379.26 38.113C378.892 38.326 374.24 33.888 368.922 28.25L359.253 18H373.408C386.802 18 387.532 18.101 386.968 19.878ZM476.385 21C483.771 25.144 486.181 29.677 488.003 42.845C488.866 49.085 489.315 54.447 489.001 54.761C488.687 55.076 481.576 54.47 473.199 53.416L457.969 51.5L452.91 42.5C450.127 37.55 445.922 29.973 443.566 25.663L439.281 17.825L455.605 18.163C470.832 18.477 472.229 18.668 476.385 21ZM422.929 147.89C419.089 150.299 385.078 184.737 383.471 187.843C380.697 193.205 385.355 200 391.804 200C395.706 200 396.466 199.367 416.357 179.542C436.473 159.494 436.884 159.002 436.884 154.936C436.884 147.411 429.574 143.72 422.929 147.89ZM461.929 152.432C460.279 153.176 441.266 171.52 419.679 193.196C380.509 232.527 380.429 232.616 380.429 236.804C380.429 243.094 385.635 247.185 391.679 245.643C392.917 245.327 412.042 226.928 434.179 204.756C470.839 168.038 474.429 164.149 474.429 161.156C474.429 156.58 472.834 154.067 468.881 152.415C464.903 150.753 465.653 150.752 461.929 152.432Z"
                  fill="white"
                />
              </svg>

              <span className="benefit_btn_tooltip">Vidros</span>
            </button>
            <button
              className={`benefit_btn ${isOnPetForm && "benefit_active"}`}
              type="button"
              onClick={handlePetForm}
            >
              <PawPrint size={40} color="#fff" />
              <span className="benefit_btn_tooltip">PET</span>
            </button>
            <button
              className={`benefit_btn ${isOnReparosForm && "benefit_active"}`}
              type="button"
              onClick={handleReparosForm}
            >
              <Wrench size={40} color="#fff" />
              <span className="benefit_btn_tooltip">Pequenos Reparos</span>
            </button>
          </Div>
          {isOnCarroReservaForm && <CarroReservaForm />}
          {isOnSeguroAPPForm && <SeguroAppForm />}
          {isOnFuneralForm && <FuneralForm />}
          {isOnVidrosForm && <VidrosForm />}
          {isOnPetForm && <PetForm />}
          {isOnReparosForm && <ReparosForm />}
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
    </>
  )
}
